const _ga = '_ga';
const _gid = '_gid';
const _gad = '_gad';
const _gat = '__gat';
const __utma = '__utma';
const __utmt = '__utmt';
const __utmc = '__utmc';
const __utmz = '__utmz';
const __utmv = '__utmv';
const __utmx = '__utmx';
const __utmxx = '__utmxx';
const __gaexp = '__gaexp';

export const GOOGLE_ANALYTICS_COOKIES = [
    _ga,
    _gid,
    _gad,
    _gat,
    __utma,
    __utmt,
    __utmc,
    __utmz,
    __utmx,
    __utmv,
    __utmxx,
    __gaexp
];



// WEBPACK FOOTER //
// ./src/util/cookies.js